// automatically generated by the FlatBuffers compiler, do not modify

export enum EscalatorUsage {
  Up = 0,
  Down = 1,
  FaultStopped = 2,
  Stopped = 3,
  Disconnected = 4
}
